import { render } from "./PayFooter.vue?vue&type=template&id=9edccc0c"
import script from "./PayFooter.vue?vue&type=script&lang=js"
export * from "./PayFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/acquiring_front_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__